const BASE_KEY = "aivr-geom-";

const TWIST_3M = "c3";
const CROSS_LEVEL = "c2";
const TRACK_GAUGE = "c1";

/**
 * Record of geometry widget preferences we wish to cache
 * @typedef {Object} WidgetStore
 * @property {boolean} showPoints
 * @property {boolean} alignToLeftRight
 * @property {string[]} selectedHeaders
 * @property {"light" | "dark"} colourScheme
 */

/**
 * @type {WidgetStore}
 */
const DEFAULT_PREFERENCES = {
    [BASE_KEY + "showPoints"]: false,
    [BASE_KEY + "alignToLeftRight"]: false,
    [BASE_KEY + "selectedHeaders"]: [TWIST_3M, CROSS_LEVEL, TRACK_GAUGE],
    [BASE_KEY + "colourScheme"]: "dark",
};

/**
 * Maps plain key to "aivr-geom-" + key
 * @param {string} key
 */
const getFullKey = (key) => {
    return BASE_KEY + key;
};

/**
 * Retrives cached geometry preferences for a given key
 * @param {keyof typeof WidgetStore} key
 */
export const getWidgetValue = (key) => {
    const fullKey = getFullKey(key);
    return JSON.parse(localStorage.getItem(fullKey)) ?? DEFAULT_PREFERENCES[fullKey];
};

/**
 *
 * @param {keyof typeof WidgetStore} key
 * @param {boolean | string[] | (prev: T) => T} value
 * @returns
 */
export const setWidgetValue = (key, value) => {
    const fullKey = getFullKey(key);

    localStorage.setItem(fullKey, JSON.stringify(value));
};
